module.exports = __webpack_public_path__ + "static/media/international.648d414b.svg";